import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  Output,
} from "@angular/core";
import {TranslateModule} from "@ngx-translate/core";

@Component({
  selector: "app-catalog-search-history",
  templateUrl: "./catalog-search-history.component.html",
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: {class: "mt-3 block w-full shrink-0"},
  imports: [TranslateModule],
})
export class CatalogSearchHistoryComponent {
  @Input({required: true}) research: string[] = [];
  @Output() researchSelected = new EventEmitter<string>();
  @Output() clearHistory = new EventEmitter<void>();
  visibleResearchCount = 5;
}
